<template>
    <div>
        <app-nav />
        <main>
            <section>
                <div class="container-fluid m-0 p-0">
                    <div class="info-grad-bg w-100">
                        <div class="row d-flex m-0 p-0 justify-content-around wow fadeIn">
                            <div v-for="(pl, i) in pls" :key="i" class="col top-m-p text-center">
                                <router-link :to="{ name: 'prices.list', params: { pl_slug: pl.slug[locale] } }" exact>
                                    <h3 class="white-text pt-3">
                                        <strong>{{ pl.name[locale] }}</strong>
                                    </h3>
                                </router-link>
                                <h6 class="white-text pb-3">{{ $t('valid from') }} {{ validityPeriod(pl) }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <router-view name="prices" />
            </section>
        </main>
        <app-footer />
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import { mapGetters } from 'vuex';
import PublicSettingsService from '@services/publicSettings.service';
import { validityPeriod } from '@services/helper.service';

export default {
    data() {
        return {
            pls: []
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        validityPeriod(pricelist) {
            return validityPeriod(pricelist);
        },
        getPriceLists() {
            PublicSettingsService.priceLists().then(res => {
                if (res.length) {
                    this.pls = res;
                    const pl = res.find(pl => pl.valid === true);
                    this.$router.push({ name: 'prices.list', params: { pl_slug: pl.slug[this.locale] } });
                }
            });
        }
    },
    components: {
        AppNav,
        AppFooter
    },
    created() {
        if (!localStorage.getItem('pricelist_route')) {
            localStorage.setItem('pricelist_route', 'prices.car');
        }
        this.getPriceLists();
    },
    metaInfo() {
        return {
            title: `${this.$t('Prices')} / ${this.$t('Vehicles')} | Autorent OÜ`
        };
    }
};
</script>
